import { gql } from '@apollo/client';
export const UPLOAD_APPLICATION_LOGO = gql`
  mutation uploadApplicationLogo($dealerId: Int!, $file: Upload!, $isSmall: Boolean) {
    uploadApplicationLogo(dealerId: $dealerId, file: $file, isSmall: $isSmall) {
      commandId
      correlationId
    }
  }
`;

export const SAVE_APPLICATION_THEME = gql`
  mutation saveApplicationTheme($dealerId: Int!, $themeName: String) {
    saveApplicationTheme(dealerId: $dealerId, themeName: $themeName) {
      commandId
      correlationId
    }
  }
`;
